function doSubmitOnboardSearch()
{
	if((ONBOARDSEARCH_FORM["sp-q"].value !='SEARCH')&&(ONBOARDSEARCH_FORM["sp-q"].value !=''))
	{ 
		document.ONBOARDSEARCH_FORM.submit();
    }
    else
	{
		alert("Please enter at least one keyword to be searched.");
		ONBOARDSEARCH_FORM["sp-q"].focus();
		return false;
	}
}